import { Module, VuexModule, Action, Mutation } from "vuex-module-decorators";
import { store } from "commonui";
import { ConversationTagResponseModel, ConversationTemplateService } from "@/services/conversation-templates";
import { ConversationBuilderService, MasterConversationDetailResponseModel } from "@/services/conversation-builder";

@Module({ namespaced: true, name: "ConversationTemplateState", store: store, dynamic: true })
export default class ConversationTemplateState extends VuexModule {
	// State for template
	private templateService = ConversationTemplateService();
	public conversationTags: ConversationTagResponseModel[] = [];
	public conversations: MasterConversationDetailResponseModel[] = [];

	@Mutation
	setConversationTags(tags: ConversationTagResponseModel[]) {
		this.conversationTags = tags;
	}
	@Mutation
	setConversations(conversations: MasterConversationDetailResponseModel[]) {
		this.conversations = conversations;
	}

	@Action
	async fetchConversationTags() {
		const tags = await this.templateService.getConversationTags();
		this.setConversationTags(tags);
	}
	@Action
	async fetchConversation() {
		const conversations = await ConversationBuilderService.getMasterConversations();
		this.setConversations(conversations.map((conversation) => ({ ...conversation, intents: 0, dialogs: 0 })));
	}
}
